import { FormSettings } from "../../models/optionalFieldSettings.model";
import { OptionalFieldService } from "../../services/optional-field-service";
import { FormSettingsHelperAbstractComponent } from "../account/manage/form-settings-helper.abstract.component";

export class FormSettingsAbstractComponent extends FormSettingsHelperAbstractComponent
{
    public formSettings: FormSettings;

    constructor(protected formName: string, protected optionalFieldService: OptionalFieldService)
    {
        super();
        if (!!formName) {
            this.optionalFieldService.getFormOptionalFields(formName).subscribe(r => this.formSettings = r);
        }
    }
}